<template>
    <va-create-layout>
        <FinancialOrderDirectPayment-form
            :title="title"
            :item="item"
        ></FinancialOrderDirectPayment-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
